const DEFAULT_BODY_RGB = { r: 17, g: 24, b: 39 };

function relativeLuminance(r, g, b) {
  const chan = (c) => {
    const x = c / 255;
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * chan(r) + 0.7152 * chan(g) + 0.0722 * chan(b);
}

function parseCssColorToRgb(input) {
  const s = String(input || '').trim();
  if (!s) return null;
  const hex = s.match(/^#([0-9a-f]{3,8})$/i);
  if (hex) {
    let h = hex[1];
    if (h.length === 3) h = h.split('').map((c) => c + c).join('');
    if (h.length >= 6) {
      return {
        r: parseInt(h.slice(0, 2), 16),
        g: parseInt(h.slice(2, 4), 16),
        b: parseInt(h.slice(4, 6), 16),
      };
    }
  }
  const rgb = s.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i);
  if (rgb) {
    return { r: Number(rgb[1]), g: Number(rgb[2]), b: Number(rgb[3]) };
  }
  return null;
}

function isLightRgb(rgb) {
  return relativeLuminance(rgb.r, rgb.g, rgb.b) > 0.62;
}

function colorFromElement(el, inheritedRgb) {
  let rgb = inheritedRgb;
  if (el.nodeType !== Node.ELEMENT_NODE) return rgb;
  const style = el.getAttribute('style') || '';
  const colorMatch = style.match(/(?:^|;)\s*color\s*:\s*([^;]+)/i);
  if (colorMatch) {
    const parsed = parseCssColorToRgb(colorMatch[1].trim());
    if (parsed) rgb = parsed;
  }
  const cls = el.getAttribute('class') || '';
  if (/\bql-color-([a-z0-9-]+)/i.test(cls)) {
    const preset = cls.match(/\bql-color-([a-z0-9-]+)/i)?.[1];
    const presetRgb = quillPresetColorRgb(preset);
    if (presetRgb) rgb = presetRgb;
  }
  return rgb;
}

function quillPresetColorRgb(token) {
  const map = {
    white: { r: 255, g: 255, b: 255 },
    red: { r: 230, g: 0, b: 0 },
    orange: { r: 255, g: 153, b: 0 },
    yellow: { r: 255, g: 255, b: 0 },
    green: { r: 0, g: 138, b: 0 },
    blue: { r: 0, g: 102, b: 204 },
    purple: { r: 153, g: 51, b: 255 },
  };
  return map[token] || null;
}

function walkLightness(el, inheritedRgb, stats) {
  if (el.nodeType === Node.TEXT_NODE) {
    const text = el.textContent || '';
    const weight = text.replace(/\s+/g, ' ').trim().length;
    if (weight > 0) {
      stats.total += weight;
      if (isLightRgb(inheritedRgb || DEFAULT_BODY_RGB)) stats.light += weight;
    }
    return;
  }
  if (el.nodeType !== Node.ELEMENT_NODE) return;
  const nextRgb = colorFromElement(el, inheritedRgb || DEFAULT_BODY_RGB);
  for (const child of el.childNodes) {
    walkLightness(child, nextRgb, stats);
  }
}

/**
 * Détecte si le HTML Quill est majoritairement en couleurs claires (texte illisible sur fond blanc).
 */
export function isRichTextMostlyLight(html) {
  const raw = String(html || '');
  if (!raw.trim() || typeof document === 'undefined') return false;
  const stripped = raw.replace(/<br\s*\/?>/gi, '').replace(/<p>\s*<\/p>/gi, '');
  if (!stripped.trim()) return false;

  const root = document.createElement('div');
  root.innerHTML = raw;
  const stats = { light: 0, total: 0 };
  for (const child of root.childNodes) {
    walkLightness(child, DEFAULT_BODY_RGB, stats);
  }
  if (stats.total < 4) return false;
  return stats.light / stats.total >= 0.45;
}

export const RICH_TEXT_DARK_PREVIEW_STYLE = {
  backgroundColor: '#0c0c0c',
  borderColor: 'rgb(38 38 38)',
  color: 'inherit',
};
